import { Article } from "@tm/models"
import { uniqueId } from "@tm/utils"
import { RimDetailsArticle } from "../model"

export const mapAccessoryKitArticle = (accessoryKitArticle: Article, rimDetailsArticle: RimDetailsArticle, quantity?: number): Article => {
    return {
        ...accessoryKitArticle,
        id: uniqueId(),
        internalId: +(accessoryKitArticle.id || 0),
        quantity: quantity ?? 1,
        showAddToBasket: true,
        isLinkedArticle: true,
        isSelected: true,
        requestErpInfo: true,
        information: accessoryKitArticle.information || [],
        vehicleInformation: accessoryKitArticle.vehicleInformation || [],
        references: accessoryKitArticle.references ?? [],
        attributes: accessoryKitArticle.attributes ?? [],
        productGroup: {
            id: accessoryKitArticle.productGroup?.id ?? rimDetailsArticle.productGroupId,
            name: accessoryKitArticle.productGroup?.name ?? rimDetailsArticle.productGroupName,
            sortId: 0,
            thumbnail: "",
        },
        supplier: {
            id: accessoryKitArticle.supplier?.id ?? rimDetailsArticle.supplierId,
            name: accessoryKitArticle.supplier?.name ?? rimDetailsArticle.supplierName,
            abbreviation: accessoryKitArticle.supplier?.name ?? rimDetailsArticle.supplierName,
            isTopPriority: false,
        },
    }
}
